<template>
  <div
    class="napaItem flex flexAlignS"
    :style="{ 'background-color': getMatChingNapStatus(data.status).bgColor }"
    v-if="data && data.requested"
  >
    <figure class="napaItemImage">
      <img
        :src="
          getAvatarLink(
            data.requested.avatar,
            getDefaultAvatar(data.requested.roleName),
          )
        "
        alt=""
      />
    </figure>
    <div class="napaItemText">
      <div>
        <h6 class="napaItemTitle">
          {{ data.requested.company }}
        </h6>
        <h3
          class="napaItemDesc"
          style="display: flex; align-items: center; flex-wrap: wrap;"
        >
          {{ data.requested.name }}
          <span
            v-if="
              data.requested.roleName == $role.USER &&
                data.requested.classification
            "
            :style="{
              'background-color': chipColor(data.requested.classification),
            }"
            class="chip-user"
          >
            {{ chipText(data.requested.classification) }}
          </span>
        </h3>
        <h6 class="napaItemTime">{{ time }}</h6>
      </div>
      <MainBadge
        :title="getMatChingNapStatus(data.status).chipText"
        :variant="getMatChingNapStatus(data.status).chipColor"
      />
    </div>

    <div>
      <MainButton
        size="large"
        :color="data.isNap ? 'green' : 'primary'"
        @click="handleView"
      >
        신청서 보기
      </MainButton>

      <button class="btn-outlined" @click="handleDelete">
        삭제하기
      </button>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import MainBadge from "@/components/badge/MainBadge.vue";
import MainButton from "@/components/button/MainButton.vue";
import moment from "moment";
import matchingColorMixins from "@/mixins/matching-color-mixins";

export default {
  name: "ItemSent",
  components: {
    MainBadge,
    MainButton,
  },
  props: ["data", "handleClickItemButtonDelete"],
  mixins: [matchingColorMixins],
  computed: {
    time() {
      return moment(this.$props.data?.submittedTime).format(
        "YYYY.MM.DD A hh:mm",
      );
    },
  },
  data() {
    return {
      isShowMatchReadPopup: false,
      isShowMatchNapPopup: false,
      isShowAnswerNapPopup: false,
    };
  },
  methods: {
    ...mapActions("matching", ["napDelete"]),
    ...mapActions("directMatching", ["deleteDirectMatching"]),
    handleDelete() {
      const params = {
        requestId: this.data.idx,
      };
      if (this.data.isNap) {
        this.napDelete(params).then(() => {
          this.$emit("onReload");
        });
      } else {
        this.deleteDirectMatching(this.data.idx).finally(() =>
          this.$emit("onReload"),
        );
      }
    },
    handleView() {
      this.$emit("clickView", this.data);
    },
  },
};
</script>
<style lang="scss" scoped>
// Section 2
.btn-outlined {
  height: 48px;
  border: 1px solid #989898;
  background-color: #fff;
  width: 100%;
  font-size: 2.1rem;
  margin-top: 16px;
  cursor: pointer;
  &.blue {
    border: 1px solid #26336a;
    background-color: #26336a;
    color: #fff;
  }

  &.green {
    border: 1px solid rgb(89, 156, 96);
    background-color: rgb(89, 156, 96);
    color: #fff;
  }
}

.chip-user {
  font-size: 1.4rem;
  padding: 4px 8px;
  border-radius: 4px;
  color: #fff;
  margin-left: 4px;
}
</style>
